import { io } from 'socket.io-client';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.kronix.click';

let socket = null;

export function getSocket() {
  return new Promise((resolve, reject) => {
    if (socket && socket.connected) {
      resolve(socket);
      return;
    }

    if (socket) {
      socket.disconnect();
    }

    const token = localStorage.getItem('admin_token');
    socket = io(API_BASE_URL, {
      auth: token ? { token } : {},
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      timeout: 10000,
    });

    const timer = setTimeout(() => {
      reject(new Error('Connection timeout'));
    }, 12000);

    socket.on('connect', () => {
      clearTimeout(timer);
      resolve(socket);
    });

    socket.on('connect_error', (err) => {
      clearTimeout(timer);
      reject(new Error('Connection failed: ' + err.message));
    });
  });
}

export function reconnectWithToken(token) {
  if (socket) {
    socket.disconnect();
  }
  localStorage.setItem('admin_token', token);
  socket = io(API_BASE_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    timeout: 10000,
  });
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Reconnect timeout')), 12000);
    socket.on('connect', () => { clearTimeout(timer); resolve(socket); });
    socket.on('connect_error', (err) => { clearTimeout(timer); reject(err); });
  });
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function emit(event, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const s = await getSocket();
      const timer = setTimeout(() => reject(new Error('Request timeout')), 10000);
      s.emit(event, data || {}, (response) => {
        clearTimeout(timer);
        if (response && response.success) resolve(response);
        else reject(new Error(response?.error || 'Request failed'));
      });
    } catch (e) {
      reject(e);
    }
  });
}
